module.exports = __webpack_public_path__ + "img/bronze-winner-badge.807934f0.svg";